module.exports = __webpack_public_path__ + "static/media/dashboard_dark.41bd3268.svg";